import React, {Component} from 'react';

/** @class ImageContent
  * A component for displaying an image.
  */
export default class ImageContent extends Component {
  /** @constructor
    * Constructs a new instance of ImageContent.
    */
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  /** @method handleClick
    * Opens the image in an overlay.
    */
  handleClick(event) {
    event.preventDefault();
    if(window.vexpo && window.vexpo.overlay)
      window.vexpo.overlay(this.props);
  }
  /** @method
   * Renders the ImageContent.
   */
  render() {
    if(this.props.url) {
      return (
        <a href={this.props.url} target="_blank">
          <img src={this.props.image} alt={this.props.name}/>
          <div dangerouslySetInnerHTML={{__html: this.props.caption}} />
        </a>
      );
    } else {
      return (
        <div onClick={this.handleClick} style={{"cursor":"pointer"}}>
          <img src={this.props.image} alt={this.props.name}/>
          <div dangerouslySetInnerHTML={{__html: this.props.caption}} />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/content/image-content.js